<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Ragione Sociale:</label>
                <span> {{ fornitoreData.ragioneSocialeFornitore }} </span>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">P.Iva:</label>
                <span> {{ fornitoreData.partitaIvaFornitore }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice fornitore:</label>
                <span>{{ fornitoreData.codiceFornitore }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Provincia: </label>
                <span> {{ fornitoreData.provinciaFornitore }}</span>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Località:</label>
                <span>{{ fornitoreData.localitaFornitore }}</span>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Indirizzo:</label>
                <span>{{ fornitoreData.indirizzoFornitore }}</span>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Cap:</label>
                <span>{{ fornitoreData.capFornitore }}</span>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Telefono:</label>
                <span>{{ fornitoreData.telefonoFornitore }}</span>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4">
                <label class="sa-label-data">Email:</label>
                <span>{{ fornitoreData.emailFornitore }}</span>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note:</label>
                <span>{{ fornitoreData.note }}</span>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "ConfigurazioniMagazzinoFornitoriDetailComponent",
    props: {
        fornitoreData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
};
</script>
